import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntChart from './AntChart';

export default forwardRef(function (props, ref) {
    const chart = useRef();

    const reload = (opts) => {
        if (chart.current) {
            chart.current.forceReload(opts);
        }
    };

    const refresh = () => {
        if (chart.current) {
            chart.current.refresh();
        }
    };

    useImperativeHandle(ref, () => ({
        refresh: refresh,
        reload: reload
    }));

    let storageKey = props.storageKey
        ? props.storageKey
        : 'searching-chart-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

          
    return (
        <React.Fragment>
            <AntChart
                ref={chart}
                API={props.API}
                url={props.url}
                table={props.table}
                isSearching={true}
                searchConditions={props.searchConditions}
                searchFields={props.searchFields}
                entityName={props.entityName}
                entityDisplay={props.entityDisplay}
                storageKey={props.storageKey ? props.storageKey : storageKey}
                keyExpr={props.keyExpr}
                loadFunc={props.loadFunc}
                fields={props.fields}
                actionItems={props.actionItems}
                onFilteredByGroupChanged={props.onFilteredByGroupChanged}
                searchText={props.searchText}
                onSearchText={props.onSearchText}
                isAllowQuery={props.isAllowQuery}
                showActionBar={props.showActionBar}
                showRefresh={props.showRefresh ? props.showRefresh : true}
                showSearchBar={props.showSearchBar}
                autoFocusSearchBar={props.autoFocusSearchBar}
                locationRefresh={props.locationRefresh}
                hideHeaderMargin={props.hideHeaderMargin}
                argumentField={props.argumentField}
                argumentFormat={props.argumentFormat}
                queryFields={props.queryFields}
                seriesTemplate={props.seriesTemplate}
                commonSeriesSettings={props.commonSeriesSettings}
                series1={props.series1}
                series2={props.series2}
                series3={props.series3}
                series4={props.series4}
                valueAxis={props.valueAxis}
                argumentAxis={props.argumentAxis}
                showLegend={props.showLegend}
                legend={props.legend}
                height={props.height}
                width={props.width}
                rotated={props.rotated}
                palette={props.palette}
                onLoaded={props.onLoaded}
            />
        </React.Fragment>
    );
});
